<template>
  <div>
    <datatable
      title="Offer Statuses"
      @edit_click="editClick"
      :fields="fields"
      :response="getAllStatuses"
      :is_createable="false"
      :show_delete="false">
    </datatable>
  </div>
</template>
<script>
// imports
import { mapActions, mapGetters, mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'

// exports
export default {
  name: 'offer-statuses-crud',
  created: function () {
    this.fetchOfferStatuses()
  },
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'Status',
          value: 'name'
        },
        {
          name: 'Color',
          value: 'color'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('offerStatuses', ['getAllStatuses'])
  },
  methods: {
    editClick (data) {
      this.create({
        designator: 'admin-list-form-modal',
        component_name: 'AdminOfferStatusesForm',
        data,
        modal_title: `Edit Status - ${data.name}`
      })
    },
    ...mapMutations('modals', ['create']),
    ...mapActions('offerStatuses', ['fetchOfferStatuses'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
